import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { AppState } from "../app.reducer";
import * as DeviceMtmaActions from './device-mtma.actions';
import { catchError, map, mergeMap, of, tap, withLatestFrom } from "rxjs";
import { selectUser } from "../user/user.selector";
import { DeviceMtmaService } from "src/app/services/device-mtma.service";
import * as NotificationsActions from '../notifications/notifications.actions';
import { Notification, NotificationLevel } from "src/app/model/notification";

@Injectable()
export class DeviceMtmaEffects {
	postMtmaImportCsv$ = createEffect(() => this.actions$.pipe(
		ofType(DeviceMtmaActions.postMtmaImportCsv),
		withLatestFrom(
			this.store.select(selectUser)
		),
		mergeMap(([action, currentUser]) => this.deviceMtmaService.postMtmaImportCsv(action.deviceId, currentUser.Id, action.mtmaUploadData)
			.pipe(
				map(resp => {
					if (resp.Success) {
						if (resp.Errors && resp.Errors.length > 0) {
							return DeviceMtmaActions.postMtmaImportCsvSuccess({ message: this.translate.instant('VCT_UPLOAD_WRITE_DATA_DONE_WITH_ERRORS'), mtmaUploadResponseData: resp });
						} else if (resp.Warnings && resp.Warnings.length > 0) {
							return DeviceMtmaActions.postMtmaImportCsvSuccess({ message: this.translate.instant('VCT_UPLOAD_WRITE_DATA_DONE_WITH_WARNING'), mtmaUploadResponseData: resp });
						} else {
							return DeviceMtmaActions.postMtmaImportCsvSuccess({ message: this.translate.instant('VCT_UPLOAD_WRITE_DATA_DONE'), mtmaUploadResponseData: resp });
						}
					} else {
						return DeviceMtmaActions.postMtmaImportCsvFailed({ errorMessage: resp.ErrorMessage, mtmaUploadResponseData: resp });
					}
				}),
				catchError(error =>
					// in this case postMtmaImportCsvFailed is catch from notifyError
					of(DeviceMtmaActions.postMtmaImportCsvFailed({ errorMessage: error.message, mtmaUploadResponseData: null }))
				)
			)
		)
	));

	// notifySuccess$ = createEffect(() => this.actions$.pipe(
	//    ofType(
	//       DeviceMtmaActions.
	//    ),
	//    tap((action) => {
	//       if (action.message === '') {
	//          return;
	//       }
	//       const notification = new Notification("DEVICE-MTMA", action.message, NotificationLevel.Success, '');
	//       this.store.dispatch(NotificationsActions.addNotification({ notification: notification, toastOnly: true }));
	//    })
	// ), { dispatch: false });

	notifyError$ = createEffect(() => this.actions$.pipe(
		ofType(
			DeviceMtmaActions.postMtmaImportCsvFailed,
		),
		tap((action) => {
			if (action.errorMessage === '') {
				return;
			}
			const notification = new Notification("DEVICE-MTMA", action.errorMessage, NotificationLevel.Error, '');
			this.store.dispatch(NotificationsActions.addNotification({ notification: notification, toastOnly: true }));
		})
	), { dispatch: false });

	constructor(
		private actions$: Actions,
		private translate: TranslateService,
		private deviceMtmaService: DeviceMtmaService,
		private store: Store<AppState>,
	) { }
}